// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1qCmY","info":"PatientInfo_info__3_y23"};